import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {find, get} from 'lodash';

import MindsetsJsSDK from "mindsets-js-sdk";
import {computeSkillLevel, computeUserLevel} from './utils';
import Constellation from './Constellation';
import ProfileTile from './ProfileTile';
import TierTile from './TierTile';
import SkillTile from './SkillTile';
import Feedback from './Feedback';

import './student_skills_passport.scss';

export default function () {
    const {student_id} = useParams();
    const [skillsData, setSkillsData] = useState([]);
    const [skillsConst, setSkillsConst] = useState([]);
    const [skillSelected, setSkillSelected] = useState(null);

    useEffect(() => {
        MindsetsJsSDK().API.get('skills_passport/student_skills_data', {
            student_id: student_id ?? 40276
        }).then((response) => {
            console.log(response);
            setSkillsConst(response.skills_const);
            setSkillsData(response.skills);
        });
    }, [student_id]);

    const skills_level_data = skillsConst.map((skill) => {
        return computeSkillLevel(skill, skillsData);
    });
    console.log('skills_level_data', skills_level_data);

    const user_level_data = computeUserLevel(skillsData);
    console.log('user_level_data', user_level_data);

    const selectSkill = (code) => {
        if (code) {
            const selected_skill = find(skills_level_data, {code});
            setSkillSelected(selected_skill);
        } else {
            setSkillSelected(null);
        }
    }

    return (
        <div id="student-skills-passport">
            <div className="container">
                <div className="flex-row flex-gap-25 flex-wrap">
                    <div className="ssp-left">
                        <Constellation
                            skills_level_data={skills_level_data}
                            selectSkill={selectSkill}
                        />
                    </div>

                    <div className="ssp-right flex-1 flex-column flex-gap-25">
                        <ProfileTile
                            user_level_data={user_level_data}
                        />

                        <TierTile
                            skills_level_data={skills_level_data}
                        />

                        <SkillTile
                            skill_data={skillSelected}
                            selectSkill={selectSkill}
                        />
                    </div>
                </div>
            </div>

            <Feedback
                first_skill_data={get(skillsData, [0], {})}
            />
        </div>
    );
}